function importAll(r: __WebpackModuleApi.RequireContext): string[] {
  return r.keys().sort().map((key) => r(key) as string);
}

const newimages = importAll(require.context('../assets/images/newimages', false, /\.jpe?g$/i));
const newest = importAll(require.context('../assets/images/newest', false, /\.jpe?g$/i));

export const CONSTRUCTION_SITE_PHOTOS: string[] = [...newimages, ...newest];
